import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

//ทำหน้าที่ resolve object promise นั่นก่อน dispatch action ไปยัง Reducer
import rootReducer from './reducer/rootReducer'

const store = () => {
    return createStore(rootReducer, composeWithDevTools<any, any>(applyMiddleware(thunkMiddleware)))
}

export default store
